import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import { useNavigate } from 'react-router-dom';

import { Article } from './Article';
import {
  ButtonContainer, DoneButton, StickyFooter, StickyHeader, Viewer, ViewerContainer
} from './ArticleViewer.styles';

import { Header } from './components/Header/Header';

const hubURL = (businessEntityUuid) => `/d/company/${businessEntityUuid}/education-studio`;
export const ArticleViewer = () => {
  const { businessEntityUuid } = useBusinessEntity();
  const navigate = useNavigate();

  const goToDashboard = () => {
    navigate(hubURL(businessEntityUuid));
  };

  const trackHeaderXClick = useButtonPressedCallback({
    elementName: 'article_viewer_close_button',
    pageCategory: 'dashboard',
    pageSection: 'education'
  });

  const trackDoneButtonClick = useButtonPressedCallback({
    elementName: 'article_viewer_done_button',
    pageCategory: 'dashboard',
    pageSection: 'education'
  });

  return (
    <ViewerContainer aria-label="article viewer">
      <StickyHeader>
        <Header
          title="Education"
          showBackButton={false}
          onClose={(event) => {
            trackHeaderXClick(event);
            goToDashboard();
          }}
        />
      </StickyHeader>
      <Viewer>
        <Article />
      </Viewer>
      <StickyFooter>
        <ButtonContainer>
          <DoneButton
            size="large"
            onClick={(event) => {
              trackDoneButtonClick(event);
              goToDashboard();
            }}
          >
            Done
          </DoneButton>
        </ButtonContainer>
      </StickyFooter>
    </ViewerContainer>
  );
};
